import { ref } from "vue";
import { useUploadProgress } from "./use-upload-progress";
import { enhancedFetch } from "../utils/enhanced-fetch";

const apiURL = import.meta.env.VITE_API_URL;

export enum UploadState {
  EMPTY,
  DEFAULT,
  UPLOADING,
  UPLOADED,
}

export function useAppManagedUpload() {
  const { upload, progress } = useUploadProgress();
  const loading = ref(false);

  async function generateS3UploadUrl(
    fileName: string,
    rootFolder: string,
  ): Promise<string> {
    const params = new URLSearchParams({ fileName, rootFolder });
    const api = `${apiURL}/video/s3/url?${params.toString()}`;

    const { url } = await enhancedFetch(api, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    }).then((response) => response.json());

    return url;
  }

  async function uploadContent(
    file: File,
    rootFolder = "video",
    onProgress?: (progress: number) => void,
  ): Promise<string> {
    if (!file.name) {
      throw new Error("File must have a name");
    }

    loading.value = true;
    try {
      const url = await generateS3UploadUrl(file.name, rootFolder);
      await upload(url, file, onProgress);
      const path = url.split("?")[0]!;
      return path;
    } catch (error) {
      console.error(error);
      throw new Error("Could not upload video");
    } finally {
      loading.value = false;
    }
  }

  return { progress, uploadContent, loading };
}
